"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBankAccountStatusFromStripeStatus = exports.isOfflinePaymentMethod = exports.OFFLINE_PAYMENT_METHODS = exports.isTippablePaymentMethod = exports.TIPPABLE_PAYMENT_METHODS = exports.isStripePaymentMethod = exports.PAYMENT_METHOD_FROM_STRIPE = exports.getNextPayoutDate = exports.CharityMCC = exports.StripeWeeklyAnchor = exports.StripeMonthlyAnchor = void 0;
const enums_1 = require("../enums");
const dates_1 = require("../enums/dates");
const dates_2 = require("./dates");
exports.StripeMonthlyAnchor = 3;
exports.StripeWeeklyAnchor = dates_1.Day.Monday;
exports.CharityMCC = 8398;
const day = {
    [dates_1.Day.Monday]: 1,
    [dates_1.Day.Tuesday]: 2,
    [dates_1.Day.Wednesday]: 3,
    [dates_1.Day.Thursday]: 4,
    [dates_1.Day.Friday]: 5,
    [dates_1.Day.Saturday]: 6,
    [dates_1.Day.Sunday]: 7,
};
const payoutWeekklyAnchorNumber = day[exports.StripeWeeklyAnchor];
const getNextPayoutDate = (date, interval, lastPayoutCreatedAtUtc) => {
    if (interval === enums_1.PayoutInterval.Monthly) {
        if (date.getDate() <= exports.StripeMonthlyAnchor &&
            (!lastPayoutCreatedAtUtc || lastPayoutCreatedAtUtc < (0, dates_2.getDateMinusNDays)(date, exports.StripeMonthlyAnchor))) {
            return new Date(date.getFullYear(), date.getMonth(), exports.StripeMonthlyAnchor, 12);
        }
        else {
            return new Date(date.getFullYear(), date.getMonth() + 1, exports.StripeMonthlyAnchor, 12);
        }
    }
    if (interval === enums_1.PayoutInterval.Weekly) {
        const baseDate = new Date(date);
        const offset = (payoutWeekklyAnchorNumber + 7 - baseDate.getDay()) % 7;
        const daysToAdd = offset === 0 ? 0 : offset; // default logic: allow same-day anchor
        const candidateDate = new Date(baseDate.setDate(baseDate.getDate() + daysToAdd));
        const isSameUtcDay = lastPayoutCreatedAtUtc &&
            candidateDate.getUTCFullYear() === lastPayoutCreatedAtUtc.getUTCFullYear() &&
            candidateDate.getUTCMonth() === lastPayoutCreatedAtUtc.getUTCMonth() &&
            candidateDate.getUTCDate() === lastPayoutCreatedAtUtc.getUTCDate();
        if (isSameUtcDay) {
            candidateDate.setDate(candidateDate.getDate() + 7);
        }
        candidateDate.setHours(12, 0, 0, 0);
        return candidateDate;
    }
    if (interval === enums_1.PayoutInterval.Daily) {
        return new Date(date.setDate(date.getDate() + 1));
    }
};
exports.getNextPayoutDate = getNextPayoutDate;
const STRIPE_PAYMENT_METHOD = [
    "card",
    "acss_debit",
    "us_bank_account",
    "sepa_debit",
    "apple_pay",
    "google_pay",
    "cashapp",
];
exports.PAYMENT_METHOD_FROM_STRIPE = {
    card: enums_1.PaymentMethod.Card,
    acss_debit: enums_1.PaymentMethod.Pad,
    us_bank_account: enums_1.PaymentMethod.Ach,
    sepa_debit: enums_1.PaymentMethod.Sepa,
    apple_pay: enums_1.PaymentMethod.ApplePayOrGooglePay,
    google_pay: enums_1.PaymentMethod.ApplePayOrGooglePay,
    cashapp: enums_1.PaymentMethod.CashApp,
};
const isStripePaymentMethod = (pm) => {
    return STRIPE_PAYMENT_METHOD.includes(pm);
};
exports.isStripePaymentMethod = isStripePaymentMethod;
exports.TIPPABLE_PAYMENT_METHODS = [
    enums_1.PaymentMethod.Card,
    enums_1.PaymentMethod.ApplePayOrGooglePay,
    enums_1.PaymentMethod.Ach,
    enums_1.PaymentMethod.Pad,
    enums_1.PaymentMethod.Sepa,
    enums_1.PaymentMethod.CashApp,
];
const isTippablePaymentMethod = (pm) => pm !== null && pm !== undefined && exports.TIPPABLE_PAYMENT_METHODS.includes(pm);
exports.isTippablePaymentMethod = isTippablePaymentMethod;
exports.OFFLINE_PAYMENT_METHODS = [enums_1.PaymentMethod.Cheque, enums_1.PaymentMethod.Cash];
const isOfflinePaymentMethod = (pm) => pm !== null && pm !== undefined && exports.OFFLINE_PAYMENT_METHODS.includes(pm);
exports.isOfflinePaymentMethod = isOfflinePaymentMethod;
const PAYABLE_STRIPE_EXTERNAL_ACCOUNT_STATUSES = ["new", "validated", "verified"];
const getBankAccountStatusFromStripeStatus = (stripeExternalAccountStatus) => {
    if (!stripeExternalAccountStatus) {
        return enums_1.BankAccountStatus.Verified;
    }
    return PAYABLE_STRIPE_EXTERNAL_ACCOUNT_STATUSES.includes(stripeExternalAccountStatus)
        ? enums_1.BankAccountStatus.Verified
        : enums_1.BankAccountStatus.Errored;
};
exports.getBankAccountStatusFromStripeStatus = getBankAccountStatusFromStripeStatus;
